import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import tglogo from '../assets/logo.png';
import LoginForm from '../components/Forms/LoginForm';
import LoadingAnimation from '../components/LoadingSpinner';
import BackgroundSVG from '../assets/Imagecode/BackgroundSVG';
import leftImage from '../assets/login-img.jpeg';
import SeveritySnackbar from '../components/Snackbar';
import axios from 'axios';
import { login2FAUser, loginUser } from '../services/authService';
import SessionExpiredDialog from '../components/Dialog/SessionExpiredDialog';
import Login2FAForm from '../components/Forms/Login2FAForm';

const LoginScreen: React.FC = () => {
    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showECG, setShowECG] = useState(false);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');

    const [showSessionExpiredDialog, setShowSessionExpiredDialog] = useState(false);

    const [login2faScreen, setlogin2faScreen]   = useState(false);
    const [otp, setOtp]                         = useState('');
    const [UserType, setUserType]               = useState('provider');
    const [UserAction, setUserAction]           = useState('2faAuthentication');
    const [UserVerifyMode, setUserVerifyMode] = useState('phone');

    const handleLogout = useCallback(() => {
        sessionStorage.clear();
        navigate('/');
    }, [navigate]);

    useEffect(() => {
        const expirationTime = sessionStorage.getItem('authTokenExpiration');
        if (expirationTime) {
            const expirationDate = new Date(parseInt(expirationTime) * 1000);
            if (expirationDate < new Date()) {
                setShowSessionExpiredDialog(true);
            }
        }
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    useEffect(() => {
        let logoutTimer: NodeJS.Timeout;
        if (showSessionExpiredDialog) {
            logoutTimer = setTimeout(() => {
                handleLogout();
            }, 10000);

            return () => clearTimeout(logoutTimer);
        }
    }, [handleLogout, showSessionExpiredDialog]);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(false);
        setLoading(true);
        setShowECG(true);

        try {
            const response = await loginUser(username, password);
            const { token, info, token_expiration_time } = response.data;
            console.log('info',response.code);
            sessionStorage.setItem('responseCode', response.code);
            if (token) {
                setSnackbarMessage('Login successful!');
                setSnackbarSeverity('success');

                // const expirationDate = new Date(token_expiration_time * 1000);

                sessionStorage.setItem('authToken', token);
                sessionStorage.setItem('userInfo', JSON.stringify(info));
                sessionStorage.setItem('authTokenExpiration', token_expiration_time.toString());
                console.log(JSON.stringify(sessionStorage, null, 2));

                navigate('/home');
            } else if((response.code === 200 || response.code === 201 ) 
                && (response.message == 'Otp sent to your registered mobile and email.'))  { // Check if 2FA is enabled
              // not an error, but 2FA is enabled
              setlogin2faScreen(true);
              setSnackbarMessage((response.message ? response.message : 'OTP Page'));
              setSnackbarSeverity('success');
            }
        } catch (error) {
            setError(true);
            if (axios.isAxiosError(error) && error.response) {
                setSnackbarMessage(error.response.data?.message || 'Login failed. Please try again.');
                setSnackbarSeverity('error');
            } else {
                const errorMessage = (error as Error).message ? (error as Error).message : 'An unexpected error occurred. Please try again.';
                setSnackbarMessage(errorMessage);
                setSnackbarSeverity('error');
            }
        } finally {
            setLoading(false);
            setShowECG(false);
            setSnackbarOpen(true);
        }
    };


    const handle2FASubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(false);
        setLoading(true);
        setShowECG(true);

        if (!otp) {
          // this.error = "Please enter email";
          setLoading(false);
          setSnackbarMessage("Enter OTP");
          setSnackbarSeverity('error');
          return false;
        }

        try {
            const response = await login2FAUser(username, password, UserType, UserAction, UserVerifyMode, otp);
            const { token, info, token_expiration_time } = response.data;
            if (token) {
                setSnackbarMessage('Login successful!');
                setSnackbarSeverity('success');

                // const expirationDate = new Date(token_expiration_time * 1000);

                sessionStorage.setItem('authToken', token);
                sessionStorage.setItem('userInfo', JSON.stringify(info));
                sessionStorage.setItem('authTokenExpiration', token_expiration_time.toString());
                console.log(JSON.stringify(sessionStorage, null, 2));

                navigate('/home');
            }
        } catch (error) {
            setError(true);
            if (axios.isAxiosError(error) && error.response) {
                setSnackbarMessage(error.response.data?.message || 'OTP Verification failed. Please try again.');
                setSnackbarSeverity('error');
            } else {
                setSnackbarMessage('An unexpected error occurred. Please try again.');
                setSnackbarSeverity('error');
            }
        } finally {
            setLoading(false);
            setShowECG(false);
            setSnackbarOpen(true);
        }
    
      }

    const cancel2FA = useCallback(() => {
        setlogin2faScreen(false);
        sessionStorage.clear();
        navigate('/');
    }, [navigate]);

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    const handleCloseSessionExpiredDialog = () => {
        setShowSessionExpiredDialog(false);
    };

    return (
        <div className="relative w-full h-screen overflow-hidden">
            <BackgroundSVG />
            <div className="flex h-screen justify-center items-center bg-cover bg-center bg-no-repeat relative overflow-hidden">
                <div className="flex flex-col md:flex-row w-full max-w-4xl h-auto md:h-[500px] xl:h-[600px] bg-white rounded-lg shadow-lg overflow-hidden relative z-10 mx-4">
                    <div className="hidden md:flex md:w-1/2 h-full">
                        <img src={leftImage} alt="Left Side" className="w-full h-full object-cover" />
                    </div>
                    <div className="flex flex-col justify-between w-full md:w-1/2 p-8">
                        <div className="flex-grow">
                            <div className="flex items-center mb-4 justify-center">
                                <img src={tglogo} alt="Logo" className="w-auto h-auto mr-2" />
                            </div>

                            {!login2faScreen && (
                                <>
                                    <h3 className="mb-8 text-center font-bold text-2xl bg-gradient-to-b from-primary to-secondary bg-clip-text text-transparent">
                                        Provider Login
                                    </h3>
                                    <LoginForm
                                        username={username}
                                        password={password}
                                        showPassword={showPassword}
                                        loading={loading}
                                        onUsernameChange={(e) => setUsername(e.target.value)}
                                        onPasswordChange={(e) => setPassword(e.target.value)}
                                        onShowPasswordToggle={() => setShowPassword(!showPassword)}
                                        onSubmit={handleLogin}
                                        helperText={error ? 'Invalid username or password' : ''}
                                        onForgotPassword={() => {
                                            throw new Error('Function not implemented.');
                                        }}
                                    />
                                </>
                            )}

                            {login2faScreen && (
                                <>
                                <div className="flex flex-col items-center justify-center">
                                    <h3 className="mb-8 text-center font-bold text-2xl bg-gradient-to-b from-primary to-secondary bg-clip-text text-transparent">
                                        Two-Factor Authentication
                                    </h3>

                                    <Login2FAForm
                                        otp={otp}
                                        onOTPChange={(e) => setOtp(e.target.value)}
                                        handle2FASubmit={handle2FASubmit}
                                        cancel2FA={cancel2FA}
                                        loading={loading}
                                        helperText={error ? 'Enter OTP' : ''}
                                    />
                                </div>
                                </>
                            )}

                            
                        </div>
                        <footer className="flex flex-col md:flex-row justify-between items-center p-4 pb-0 text-gray-700">
                            <p className="text-sm mt-4 md:mt-0">© 2024 A2ZHealth</p>
                            <div className="flex md:space-x-4 mt-4 md:mt-0">
                                <a href="/privacy" className="hover:underline text-sm">Privacy</a>
                                <a href="/legal" className="hover:underline text-sm">Legal</a>
                                <a href="/contact" className="hover:underline text-sm">Contact</a>
                            </div>
                        </footer>
                    </div>
                </div>
                <LoadingAnimation show={showECG} onComplete={() => setShowECG(false)} />
                <SeveritySnackbar
                    open={snackbarOpen}
                    message={snackbarMessage}
                    severity={snackbarSeverity}
                    onClose={handleCloseSnackbar}
                />
            </div>

            {showSessionExpiredDialog && (
                <SessionExpiredDialog onLogout={handleLogout} onClose={handleCloseSessionExpiredDialog} />
            )}
        </div>
    );
};

export default LoginScreen;
